var _style, _g, _g2, _g3, _circle, _rect, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaceLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1197.2 257.8",
    style: {
      enableBackground: "new 0 0 1197.2 257.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004FFF;}\n\t.st1{fill:#F1F2F2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Layer_x3E_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_2_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 783.3,
    cy: 128.8,
    r: 28.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 784.4,
    y: 124.9,
    className: "st0",
    width: 306,
    height: 7.8
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210,146.9c8.1,10.6,12.1,23.8,12.1,39.5c0,21.7-8.3,38.4-25,50.2c-16.7,11.8-41,17.7-72.9,17.7H0V4.3h117.1 c29.5,0,52.3,5.8,68.2,17.3c15.9,11.6,23.9,27.4,23.9,47.7c0,12.4-2.9,23.3-8.6,32.9c-5.7,9.5-13.6,16.9-23.6,22.1 C191,128.8,201.9,136.3,210,146.9z M46.5,40.7v68.9h65.7c16.2,0,28.6-2.9,37.3-8.8c8.7-5.8,13-14.3,13-25.5 c0-11.4-4.3-20.1-13-25.9s-21.1-8.8-37.3-8.8L46.5,40.7L46.5,40.7z M175.4,181.8c0-24-18-36.1-53.9-36.1h-75v72.1h75 C157.4,217.8,175.4,205.8,175.4,181.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M508.8,196.4h-125l-24.6,57.9h-47.9l112.5-250h45.7l112.9,250h-48.6L508.8,196.4z M493.5,160L446.4,50.7 L399.6,160H493.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1197.2,215.3v39h-187.5V4.3h182.5v38.9h-136.1v65h120.7v38.2h-120.7v68.9H1197.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M849.3,186.6c-16.1,18.4-39.7,30-66,30c-48.5,0-87.7-39.3-87.7-87.7c0-48.5,39.3-87.7,87.7-87.7 c26.5,0,50.2,11.7,66.3,30.3l31.1-27C857.1,17.2,822.2,0,783.3,0c-71.2,0-128.9,57.7-128.9,128.9s57.7,128.9,128.9,128.9 c38.7,0,73.4-17.1,97-44.1L849.3,186.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaceLogoLight);
export default __webpack_public_path__ + "static/media/BACE_logo_light.d03c71e7030f6df1f2aefb02e15d613b.svg";
export { ForwardRef as ReactComponent };